module.exports = __webpack_public_path__ + "76a8fcf9deab298c59edd92f6ce5bee5.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/statistics/statistics.html
// module id = 2363
// module chunks = 0